<template>
  <div>
    <button @click="resend" class="btn btn-danger">
      {{ "next_step" | setText("Получить новую смс") }}
    </button>
    <!-- <timer v-if="transaction" :before="transaction.created_at" /> -->
    <Br />
    <Br />
    <fg-input
      :type="`number`"
      :label="`Введите код из смс, которое пришло клиенту`"
      v-model="code"
    ></fg-input>
    <br />
    <br />
    <div class="install-control">
      <button @click="next" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import Purchases from "@/components/Item/Order/Purchases";
// import Timer from "@/components/Timer";
import { logger } from "../../../plugins/functions";
export default {
  components: {
    Purchases,
    // Timer,
  },
  props: {
    partner: {
      default: function () {
        return {};
      },
    },
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    hash: {
      default: null,
    },
    contract: {
      default: 0,
    },
    index: {
      default: 0,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    next() {
      this.save();
    },
    save() {
      this.$loading(true);
      logger(this.$http, {
        name: "Подтверждение заказа в #INTEND",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });
      this.$http({
        url: `${this.partner["endpoint_url"]}cheque/confirm`,
        method: "POST",
        data: {
          code: this.code,
          ref_id: this.contract,
        },
        headers: {
          "api-key": `${this.partner["api_public_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${this.hash}`,
        },
      })
        .then((response) => {
          if (response.data.data) {
            const partner_status = response.data.data.status;
            if (partner_status == 1 || partner_status == 3) {
              this.message = "Заказ успешно подвтержден (ожидает оплату)";
              this.createTransaction({
                client_confirmed: 1,
                system_confirmed: 0,
                exchange_additional_id: response.data.data.order_id,
              });
            } else if (partner_status == 2) {
              this.message = "Заказ успешно подвтержден";
              this.createTransaction({
                client_confirmed: 1,
                system_confirmed: 1,
                exchange_additional_id: response.data.data.order_id,
              });
            }
            this.$emit("next", 6);
          } else if (response.data.error) {
            this.message = response.data.error["message"];
          } else {
            this.message = "Неверный код";
          }
          if (this.message) {
            this.$notify({
              title: this.partner.name,
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

            logger(this.$http, {
              name: "Подтверждение заказа в #INTEND",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }
        })
        .catch((error) => {
          alert("Ошибка партнера");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    resend() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}cheque/resend`,
        method: "POST",
        data: {
          ref_id: this.contract,
        },
        headers: {
          "api-key": `${this.partner["api_public_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${this.hash}`,
        },
      })
        .then((response) => {
          if (response.data.data) {
            this.code = "";
            this.message = "Ожидайте смс";
          } else if (response.data.error) {
            this.message = response.data.error.message;
          } else {
            this.message = "Ошибка сервера";
            //this.$emit('next', 0);
            this.$emit("next", 5); //test
          }

          if (this.message) {
            this.$notify({
              title: this.partner.name,
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Создание заказа в #INTEND",
            description: "Системная ошибка #INTEND",
            model_type: "order",
            model_id: this.order.id,
          });
          alert("Ошибка партнера");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: "",
      code: "",
    };
  },
};
</script>
<style lang="scss">
</style>
